export default __webpack_public_path__ + "0bc694c68cb6c8f60f1605c7e3f8f284.js";